export const COMPARISON_ENTRYPOINTS_ENABLED_CONFIG = 'Newbuilding.ComparisonEntrypoints.Enabled';
export const ADD_TO_COMPARE_BANNER_TEXT = 'Сравнить';
